import type { Tab } from "../types";
import { stripHtml } from "../util/text";
import { isHidden } from "../util/rule";
import { useAnswers } from "../state/AnswersContext";

type Props = {
  tabs: Tab[];
  activeId: string | undefined;
  onSelect: (id: string) => void;
};

// Force-show set: these tabs render regardless of their CPQ hide rule.
// DEBUG is hidden in production CPQ but useful here while we build out
// the configurator.
const FORCE_SHOW_TAB_CODES = new Set<string>(["DEBUG"]);

export default function TabBar({ tabs, activeId, onSelect }: Props) {
  const { answers } = useAnswers();

  const visibleTabs = tabs.filter(
    (t) =>
      FORCE_SHOW_TAB_CODES.has(t.custrecord_cpqc_tab_code) ||
      !isHidden(
        {
          hideRule: t.custrecord_cpqc_tab_hide_rule,
          parsedHideRule: t.custrecord_cpqc_tab_parsed_hide_rule,
        },
        answers
      )
  );

  return (
    <nav className="cpq-tabbar" role="tablist">
      {visibleTabs.map((t) => {
        const label = stripHtml(t.custrecord_cpqc_tab_label_html) || t.name;
        const isActive = t.id === activeId;
        return (
          <button
            key={t.id}
            role="tab"
            aria-selected={isActive}
            className={`cpq-tab ${isActive ? "is-active" : ""}`}
            onClick={() => onSelect(t.id)}
          >
            {label}
          </button>
        );
      })}
    </nav>
  );
}
